import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { siteInfo } from "@/mocks/site";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ContactForm from "@/components/feature/ContactForm";

const SITE = "https://zozxnbl.cn";

export default function Guanyu() {
  useSeo({
    title: "关于我们 | 51爆料网品牌介绍与内容原则",
    description:
      "了解 51爆料网的品牌定位、发展理念与内容原则。我们以栏目导航为入口，坚持多方求证、可核验、不猎奇、有后续，为读者提供更有参考价值的内容。",
    keywords: "51爆料网,关于我们,内容原则,品牌介绍,网站定位",
    canonical: "/guanyu",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "关于我们 - 51爆料网",
        url: `${SITE}/guanyu`,
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "51爆料网",
        url: SITE,
        email: siteInfo.email,
        foundingDate: siteInfo.foundedYear,
        slogan: siteInfo.slogan,
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: SITE },
          { "@type": "ListItem", position: 2, name: "关于我们", item: `${SITE}/guanyu` },
        ],
      },
    ],
  });

  return (
    <>
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-[1280px] px-6 py-8 md:py-12">
          <Breadcrumb items={[{ label: "关于我们" }]} />
          <div className="mt-5 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-7">
              <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
                <span className="h-3 w-1 rounded-full bg-primary-500" />
                关于本站
              </p>
              <h1 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
                关于 51爆料网
              </h1>
              <p className="mt-4 max-w-2xl text-base leading-relaxed text-foreground-600">
                {siteInfo.intro}
              </p>
              <p className="mt-4 font-heading text-lg font-bold text-primary-700">
                「{siteInfo.slogan}」
              </p>
            </div>
            <div className="lg:col-span-5">
              <div className="overflow-hidden rounded-lg border border-background-200">
                <div className="h-56 w-full bg-background-200 md:h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20minimal%20desk%20flat%20lay%20with%20open%20notebooks%2C%20highlighted%20documents%20and%20a%20cup%20of%20tea%2C%20soft%20afternoon%20light%2C%20cream%20and%20terracotta%20tones%2C%20editorial%20photography&width=1000&height=720&seq=about-team-visual&orientation=landscape"
                    alt="51爆料网内容团队的工作场景插画"
                    title="51爆料网 内容团队"
                    className="h-full w-full object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-6 py-12">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:col-span-2">
            <h2 className="font-heading text-xl font-bold text-foreground-950">网站定位</h2>
            <p className="mt-3 text-sm leading-loose text-foreground-600">
              51爆料网不是一个大而全的站内搜索，而是一个「有明确入口」的内容门户。我们把内容分为首页栏目、专题频道与内容板块三类，
              再用一个栏目导航页把它们集中呈现。对读者来说，这意味着更短的查找路径；对内容本身来说，这意味着每个栏目都有清晰的边界与预期。
            </p>
            <p className="mt-3 text-sm leading-loose text-foreground-600">
              我们更希望做「看完之后知道下一步怎么做」的内容——比如遇到消费纠纷时了解处理顺序，遇到流行说法时知道怎么自行核验，
              而不是只停留在一句情绪化的结论。
            </p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="font-heading text-xl font-bold text-foreground-950">发展理念</h2>
            <ul className="mt-3 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2.5">
                <i className="ri-focus-3-line mt-0.5 text-primary-600" />
                先把入口做清楚，再谈内容多少
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-focus-3-line mt-0.5 text-primary-600" />
                宁可更新慢一点，也要信息准确
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-focus-3-line mt-0.5 text-primary-600" />
                出现偏差时及时澄清，而非沉默
              </li>
            </ul>
          </div>
        </div>

        <dl className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {siteInfo.stats.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-200 bg-background-100 p-5 text-center">
              <dt className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{stat.value}</dt>
              <dd className="mt-1.5 text-xs text-foreground-600">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="border-y border-background-200 bg-background-100">
        <div className="mx-auto max-w-[1280px] px-6 py-12">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">内容原则</h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            这四条原则贯穿我们所有栏目，也是我们在内容出现争议时的判断依据。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {siteInfo.principles.map((p) => (
              <div key={p.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${p.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-6 py-12">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">读者怎么说</h2>
        <p className="mt-2 text-sm text-foreground-600">以下为读者反馈整理，已做匿名处理。</p>
        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
          {siteInfo.testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6">
              <i className="ri-double-quotes-l text-2xl text-primary-300" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {t.text}
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-2.5 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-sm font-bold text-secondary-900">
                  {t.name.charAt(0)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{t.name}</span>
                  <span className="block text-xs text-foreground-500">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section className="border-t border-background-200 bg-background-100">
        <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-6 py-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              联系与线索反馈
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              如果你有想提供的线索、发现内容需要更正，或希望讨论转载与授权，都可以通过下面的方式联系我们。
              我们通常会在几个工作日内查看。
            </p>
            <ul className="mt-6 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-mail-line" />
                </span>
                <span>
                  <span className="block font-medium text-foreground-950">邮箱</span>
                  <a href={`mailto:${siteInfo.email}`} className="text-foreground-600 transition-colors hover:text-primary-600">
                    {siteInfo.email}
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-wechat-line" />
                </span>
                <span>
                  <span className="block font-medium text-foreground-950">微信公众号</span>
                  <span className="text-foreground-600">{siteInfo.wechat}</span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-compass-3-line" />
                </span>
                <span>
                  <span className="block font-medium text-foreground-950">查找内容</span>
                  <Link to="/lanmu" className="text-foreground-600 transition-colors hover:text-primary-600">
                    先到栏目导航页定位板块
                  </Link>
                </span>
              </li>
            </ul>
          </div>
          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}